import { prependModuleName } from '@/utils/vueUtils';
// eslint-disable-next-line no-shadow
var EHubMainReportMutations;
(function (EHubMainReportMutations) {
    EHubMainReportMutations["SET_FILTER_OPTION"] = "SET_FILTER_OPTION";
    EHubMainReportMutations["GET_HUB_MAIN_REPORT"] = "GET_HUB_MAIN_REPORT";
    EHubMainReportMutations["GET_SELECTED_HUB_INFO"] = "GET_SELECTED_HUB_INFO";
    EHubMainReportMutations["RESET_HUB_MAIN_REPORT"] = "RESET_HUB_MAIN_REPORT";
})(EHubMainReportMutations || (EHubMainReportMutations = {}));
const IHubMainReportActionTypes = {
    setFilterOption: 'setFilterOption',
    getHubMainReport: 'getHubMainReport',
    getSelectedHubInfo: 'getSelectedHubInfo',
    resetHubMainReport: 'resetHubMainReport',
};
const IHubMainReportActionTypePath = prependModuleName('hubAdjustment/hubMainReport', IHubMainReportActionTypes);
export { EHubMainReportMutations, IHubMainReportActionTypes, IHubMainReportActionTypePath, };
